<template>
  <div
    v-if="initdisplay"
  >
    <v-menu
      v-model="dialog"
      :close-on-click="false"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          id="print-screen"
          class="control"
          small
          style="border-radius:10px; margin: 0.25em;width: 3em;"
          fab
          v-on="on"
          @click="selectingPrint=true;"
        >
          <v-icon>mdi-printer mdi-24px</v-icon>
        </v-btn>
      </template>
      <v-card
        style="max-height: 60vh;overflow:auto;"
      >
        <v-card-title>
          <span class="headline">{{ $t('printMap.heading') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form
              ref="printForm"
            >
              <v-text-field
                v-model="printSettings['printheading']"
                :label="$t('printMap.title')"
                name="printheading"
              />
              <v-select
                v-model="printSettings['scales']"
                :items="scales"
                :label="$t('printMap.scale')"
                name="scales"
              />
              <v-select
                v-model="printSettings['paper']"
                :items="paperdims"
                :label="$t('printMap.paper')"
                name="paper"
              />
              <v-select
                v-model="printSettings['orientation']"
                :items="$t('printMap.orientations')"
                :label="$t('printMap.orientation')"
                name="orientation"
              />
              <v-select
                v-model="printSettings['res']"
                :items="res"
                :label="$t('printMap.resolution')"
                name="resolution"
              />
              <!--{{ printSettings }}-->
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false;selectingPrint=false;"
          >
            {{ $t('various.abort') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false;selectingPrint=false;print(printSettings);"
          >
            {{ $t('various.print') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
    <div
      v-show="selectingPrint"
      id="printSelection"
      class="print-selection"
      :style="{
        height:`${printSelectionHeight}px`,
        width:`${printSelectionWidth}px`,
        top: `${marginH}px`,
        left: `${marginV}px`
      }"
    />
    <v-fade-transition>
      <div
        v-show="printing"
        id="printSplash"
        style="opacity:0.85;"
        :style="{backgroundColor:background}"
      >
        <div
          class="content-box"
        >
          <p class="content">
            <v-icon
              style="margin: auto"
            >
              mdi-loading mdi-spin mdi-48px
            </v-icon>
          </p>
        </div>
      </div>
    </v-fade-transition>
    <object
      id="compassIcon"
      data="./icons/northArrow.svg"
      width="100"
      height="100"
      type="image/svg+xml"
      style="display:none;"
    />
  </div>
</template>

<script>

import * as proj from 'ol/proj';
import { EventBus } from '../../event-bus';
import { Mapable } from '../../mixins/Mapable';


export default {
  name: 'PrintMap',
  mixins: [Mapable],
  data() {
    return {
      initdisplay: this.$appConfig.showPrintOption,
      baseColor: this.$appConfig.baseColor,
      iconColor: this.$appConfig.iconColor,
      background: this.$appConfig.backgroundColor,
      logo: this.$appConfig.logo,
      fab: false,
      dialog: false,
      selectingPrint: false,
      printing: false,
      printheading: '',
      activatedScales: this.$appConfig.printOptions.scales,
      activatedPaperSizes: this.$appConfig.printOptions.paperSizes,
      scales: [],
      availableScales: [{
        text: '1:500',
        value: {
          scalenumber: 500,
          scaletext2cm: '10m',
        },
      }, {
        text: '1:1000',
        value: {
          scalenumber: 1000,
          scaletext2cm: '20m',
        },
      }, {
        text: '1:2500',
        value: {
          scalenumber: 2500,
          scaletext2cm: '50m',
        },
      }, {
        text: '1:5000',
        value: {
          scalenumber: 5000,
          scaletext2cm: '100m',
        },
      }, {
        text: '1:10000',
        value: {
          scalenumber: 10000,
          scaletext2cm: '200m',
        },
      }, {
        text: '1:20000',
        value: {
          scalenumber: 20000,
          scaletext2cm: '400m',
        },
      }, {
        text: '1:50000',
        value: {
          scalenumber: 50000,
          scaletext2cm: '1km',
        },
      }, {
        text: '1:100000',
        value: {
          scalenumber: 100000,
          scaletext2cm: '2km',
        },
      }, {
        text: '1:200000',
        value: {
          scalenumber: 200000,
          scaletext2cm: '4km',
        },
      }, {
        text: '1:500000',
        value: {
          scalenumber: 500000,
          scaletext2cm: '10km',
        },
      }, {
        text: '1:1000000',
        value: {
          scalenumber: 1000000,
          scaletext2cm: '20km',
        },
      },
      ],
      res: [72, 150, 300],
      paperdims: [],
      availablePaperdims: [
        {
          text: 'DIN A0',
          value: {
            format: 'a0',
            dim: [1189, 841],
          },
        }, {
          text: 'DIN A1',
          value: {
            format: 'a1',
            dim: [841, 594],
          },
        }, {
          text: 'DIN A2',
          value: {
            format: 'a2',
            dim: [594, 420],
          },
        }, {
          text: 'DIN A3',
          value: {
            format: 'a3',
            dim: [420, 297],
          },
        }, {
          text: 'DIN A4',
          value: {
            format: 'a4',
            dim: [297, 210],
          },
        }, {
          text: 'DIN A5',
          value: {
            format: 'a5',
            dim: [210, 148],
          },
        },
      ],
      printSettings: {
        printheading: '',
        scales: {
          scalenumber: 5000,
          scaletext2cm: '100m',
        },
        paper: {
          format: 'a4',
          dim: [297, 210],
        },
        orientation: 'landscape',
        res: 150,
      },
      mapBound: false,
      printWhitespaceLandscape: {
        top: 5,
        right: 5,
        bottom: 30,
        left: 5,
      },
    };
  },
  computed: {
    printSelectionHeight() {
      if (this.mapBound) {
        const ps = this.printSettings;
        let paperheight = ps.paper.dim[0];
        if (ps.orientation === 'landscape') {
          paperheight = ps.paper.dim[1];
        }
        const mz = ps.scales.scalenumber;
        const paperheightM = mz * (paperheight / 1000);
        const boxheight = paperheightM / this.$store.state.currentMetrePerPixel;
        // const boxheight = window.innerHeight * pixelheight;
        return boxheight;
      }
      return 0;
    },
    printSelectionWidth() {
      if (this.mapBound) {
        const ps = this.printSettings;
        let paperwidth = ps.paper.dim[1];
        if (ps.orientation === 'landscape') {
          paperwidth = ps.paper.dim[0];
        }
        const mz = ps.scales.scalenumber;
        const paperwidthM = mz * (paperwidth / 1000);
        const boxwidth = paperwidthM / this.$store.state.currentMetrePerPixel;
        // const boxheight = window.innerHeight * pixelheight;
        return boxwidth;
      }
      return 0;
    },
    marginH() {
      return (window.innerHeight - this.printSelectionHeight) / 2;
    },
    marginV() {
      return (window.innerWidth - this.printSelectionWidth) / 2;
    },
  },
  created() {
    EventBus.$on('pixelresolution', (pixres) => {
      this.mPerPx = pixres;
    });
  },
  mounted() {
    EventBus.$on('end-print-mode', () => {
      this.printing = false;
    });
    EventBus.$on('available-scales', (list) => {
      list.forEach((acs) => {
        this.availableScales.forEach((avs) => {
          if (acs === avs.value.scalenumber) {
            this.scales.push(avs);
          }
        });
      });
      this.activatedPaperSizes.forEach((acp) => {
        this.availablePaperdims.forEach((avp) => {
          if (acp === avp.value.format) {
            this.paperdims.push(avp);
          }
        });
      });
    });
  },
  methods: {
    onMapBound() {
      this.mapBound = true;
    },
    print(printSettings) {
      this.printing = true;
      EventBus.$emit('print', printSettings);
    },
    getPointResolution() { // get m per px
      const me = this;
      return proj.getPointResolution(me.map.getView().getProjection(), me.map.getView().getResolution(), me.map.getView().getCenter());
    },
    pad(d) {
      return (d < 10) ? `0${d.toString()}` : d.toString();
    },
  },
};

</script>

<style scoped>
.print-selection {
  position: fixed;
  outline: 10000px solid rgba(0,0,0,0.6);
  z-index:100;
  pointer-events: none;
}
#printSplash {
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }
</style>
